var Qe = (i, f, c) => {
  if (!f.has(i))
    throw TypeError("Cannot " + c);
};
var se = (i, f, c) => (Qe(i, f, "read from private field"), c ? c.call(i) : f.get(i)), Ze = (i, f, c) => {
  if (f.has(i))
    throw TypeError("Cannot add the same private member more than once");
  f instanceof WeakSet ? f.add(i) : f.set(i, c);
}, Je = (i, f, c, w) => (Qe(i, f, "write to private field"), w ? w.call(i, c) : f.set(i, c), c);
const Ke = [
  "Aztec",
  "Codabar",
  "Code128",
  "Code39",
  "Code93",
  "DataBar",
  "DataBarExpanded",
  "DataMatrix",
  "DXFilmEdge",
  "EAN-13",
  "EAN-8",
  "ITF",
  "Linear-Codes",
  "Matrix-Codes",
  "MaxiCode",
  "MicroQRCode",
  "None",
  "PDF417",
  "QRCode",
  "rMQRCode",
  "UPC-A",
  "UPC-E"
];
function Ha(i) {
  return i.join("|");
}
function Ba(i) {
  const f = tr(i);
  let c = 0, w = Ke.length - 1;
  for (; c <= w; ) {
    const v = Math.floor((c + w) / 2), $ = Ke[v], B = tr($);
    if (B === f)
      return $;
    B < f ? c = v + 1 : w = v - 1;
  }
  return "None";
}
function tr(i) {
  return i.toLowerCase().replace(/_-\[\]/g, "");
}
function Ua(i, f) {
  return i.Binarizer[f];
}
function Va(i, f) {
  return i.CharacterSet[f];
}
const La = [
  "Text",
  "Binary",
  "Mixed",
  "GS1",
  "ISO15434",
  "UnknownECI"
];
function Ya(i) {
  return La[i.value];
}
function za(i, f) {
  return i.EanAddOnSymbol[f];
}
function Na(i, f) {
  return i.TextMode[f];
}
const dt = {
  formats: [],
  tryHarder: !0,
  tryRotate: !0,
  tryInvert: !0,
  tryDownscale: !0,
  binarizer: "LocalAverage",
  isPure: !1,
  downscaleFactor: 3,
  downscaleThreshold: 500,
  minLineCount: 2,
  maxNumberOfSymbols: 255,
  tryCode39ExtendedMode: !1,
  validateCode39CheckSum: !1,
  validateITFCheckSum: !1,
  returnCodabarStartEnd: !1,
  returnErrors: !1,
  eanAddOnSymbol: "Read",
  textMode: "Plain",
  characterSet: "Unknown"
};
function rr(i, f) {
  return {
    ...f,
    formats: Ha(f.formats),
    binarizer: Ua(i, f.binarizer),
    eanAddOnSymbol: za(
      i,
      f.eanAddOnSymbol
    ),
    textMode: Na(i, f.textMode),
    characterSet: Va(
      i,
      f.characterSet
    )
  };
}
function nr(i) {
  return {
    ...i,
    format: Ba(i.format),
    eccLevel: i.eccLevel,
    contentType: Ya(i.contentType)
  };
}
const Ga = {
  locateFile: (i, f) => {
    const c = i.match(/_(.+?)\.wasm$/);
    return c ? `https://fastly.jsdelivr.net/npm/zxing-wasm@1.2.4/dist/${c[1]}/${i}` : f + i;
  }
};
let ue = /* @__PURE__ */ new WeakMap();
function ce(i, f) {
  var c;
  const w = ue.get(i);
  if (w != null && w.modulePromise && (f === void 0 || Object.is(f, w.moduleOverrides)))
    return w.modulePromise;
  const v = (c = f != null ? f : w == null ? void 0 : w.moduleOverrides) != null ? c : Ga, $ = i({
    ...v
  });
  return ue.set(i, {
    moduleOverrides: v,
    modulePromise: $
  }), $;
}
function Xa(i, f) {
  ue.set(i, {
    moduleOverrides: f
  });
}
async function qa(i, f, c = dt) {
  const w = {
    ...dt,
    ...c
  }, v = await ce(i), { size: $ } = f, B = new Uint8Array(await f.arrayBuffer()), U = v._malloc($);
  v.HEAPU8.set(B, U);
  const V = v.readBarcodesFromImage(
    U,
    $,
    rr(v, w)
  );
  v._free(U);
  const H = [];
  for (let M = 0; M < V.size(); ++M)
    H.push(
      nr(V.get(M))
    );
  return H;
}
async function Qa(i, f, c = dt) {
  const w = {
    ...dt,
    ...c
  }, v = await ce(i), {
    data: $,
    width: B,
    height: U,
    data: { byteLength: V }
  } = f, H = v._malloc(V);
  v.HEAPU8.set($, H);
  const M = v.readBarcodesFromPixmap(
    H,
    B,
    U,
    rr(v, w)
  );
  v._free(H);
  const K = [];
  for (let L = 0; L < M.size(); ++L)
    K.push(
      nr(M.get(L))
    );
  return K;
}
({
  ...dt,
  formats: [...dt.formats]
});
var Ut = (() => {
  var i = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return function(f = {}) {
    var c = f, w, v;
    c.ready = new Promise((e, t) => {
      w = e, v = t;
    });
    var $ = Object.assign({}, c), B = "./this.program", U = typeof window == "object", V = typeof Bun < "u", H = typeof importScripts == "function";
    typeof process == "object" && typeof process.versions == "object" && process.versions.node;
    var M = "";
    function K(e) {
      return c.locateFile ? c.locateFile(e, M) : M + e;
    }
    var L;
    (U || H || V) && (H ? M = self.location.href : typeof document < "u" && document.currentScript && (M = document.currentScript.src), i && (M = i), M.startsWith("blob:") ? M = "" : M = M.substr(0, M.replace(/[?#].*/, "").lastIndexOf("/") + 1), H && (L = (e) => {
      var t = new XMLHttpRequest();
      return t.open("GET", e, !1), t.responseType = "arraybuffer", t.send(null), new Uint8Array(t.response);
    }));
    var ht = c.print || console.log.bind(console), X = c.printErr || console.error.bind(console);
    Object.assign(c, $), $ = null, c.arguments && c.arguments, c.thisProgram && (B = c.thisProgram), c.quit && c.quit;
    var tt;
    c.wasmBinary && (tt = c.wasmBinary), typeof WebAssembly != "object" && Tt("no native wasm support detected");
    var at, _t = !1, Y, W, ot, ft, R, _, le, de;
    function he() {
      var e = at.buffer;
      c.HEAP8 = Y = new Int8Array(e), c.HEAP16 = ot = new Int16Array(e), c.HEAPU8 = W = new Uint8Array(e), c.HEAPU16 = ft = new Uint16Array(e), c.HEAP32 = R = new Int32Array(e), c.HEAPU32 = _ = new Uint32Array(e), c.HEAPF32 = le = new Float32Array(e), c.HEAPF64 = de = new Float64Array(e);
    }
    var fe = [], pe = [], me = [];
    function pr() {
      if (c.preRun)
        for (typeof c.preRun == "function" && (c.preRun = [c.preRun]); c.preRun.length; )
          vr(c.preRun.shift());
      Vt(fe);
    }
    function mr() {
      Vt(pe);
    }
    function yr() {
      if (c.postRun)
        for (typeof c.postRun == "function" && (c.postRun = [c.postRun]); c.postRun.length; )
          wr(c.postRun.shift());
      Vt(me);
    }
    function vr(e) {
      fe.unshift(e);
    }
    function gr(e) {
      pe.unshift(e);
    }
    function wr(e) {
      me.unshift(e);
    }
    var et = 0, pt = null;
    function $r(e) {
      var t;
      et++, (t = c.monitorRunDependencies) === null || t === void 0 || t.call(c, et);
    }
    function br(e) {
      var t;
      if (et--, (t = c.monitorRunDependencies) === null || t === void 0 || t.call(c, et), et == 0 && pt) {
        var r = pt;
        pt = null, r();
      }
    }
    function Tt(e) {
      var t;
      (t = c.onAbort) === null || t === void 0 || t.call(c, e), e = "Aborted(" + e + ")", X(e), _t = !0, e += ". Build with -sASSERTIONS for more info.";
      var r = new WebAssembly.RuntimeError(e);
      throw v(r), r;
    }
    var Cr = "data:application/octet-stream;base64,", ye = (e) => e.startsWith(Cr), it;
    it = "zxing_reader.wasm", ye(it) || (it = K(it));
    function ve(e) {
      if (e == it && tt)
        return new Uint8Array(tt);
      if (L)
        return L(e);
      throw "both async and sync fetching of the wasm failed";
    }
    function _r(e) {
      return !tt && (U || H || V) && typeof fetch == "function" ? fetch(e, {
        credentials: "same-origin"
      }).then((t) => {
        if (!t.ok)
          throw `failed to load wasm binary file at '${e}'`;
        return t.arrayBuffer();
      }).catch(() => ve(e)) : Promise.resolve().then(() => ve(e));
    }
    function ge(e, t, r) {
      return _r(e).then((n) => WebAssembly.instantiate(n, t)).then(r, (n) => {
        X(`failed to asynchronously prepare wasm: ${n}`), Tt(n);
      });
    }
    function Tr(e, t, r, n) {
      return !e && typeof WebAssembly.instantiateStreaming == "function" && !ye(t) && typeof fetch == "function" ? fetch(t, {
        credentials: "same-origin"
      }).then((a) => {
        var o = WebAssembly.instantiateStreaming(a, r);
        return o.then(n, function(s) {
          return X(`wasm streaming compile failed: ${s}`), X("falling back to ArrayBuffer instantiation"), ge(t, r, n);
        });
      }) : ge(t, r, n);
    }
    function Pr() {
      var e = {
        a: va
      };
      function t(n, a) {
        return A = n.exports, at = A.ma, he(), Ae = A.qa, gr(A.na), br(), A;
      }
      $r();
      function r(n) {
        t(n.instance);
      }
      if (c.instantiateWasm)
        try {
          return c.instantiateWasm(e, t);
        } catch (n) {
          X(`Module.instantiateWasm callback failed with error: ${n}`), v(n);
        }
      return Tr(tt, it, e, r).catch(v), {};
    }
    var Vt = (e) => {
      for (; e.length > 0; )
        e.shift()(c);
    };
    c.noExitRuntime;
    var Pt = [], Et = 0, Er = (e) => {
      var t = new Lt(e);
      return t.get_caught() || (t.set_caught(!0), Et--), t.set_rethrown(!1), Pt.push(t), Ve(t.excPtr), t.get_exception_ptr();
    }, q = 0, Ar = () => {
      T(0, 0);
      var e = Pt.pop();
      Ue(e.excPtr), q = 0;
    };
    class Lt {
      constructor(t) {
        this.excPtr = t, this.ptr = t - 24;
      }
      set_type(t) {
        _[this.ptr + 4 >> 2] = t;
      }
      get_type() {
        return _[this.ptr + 4 >> 2];
      }
      set_destructor(t) {
        _[this.ptr + 8 >> 2] = t;
      }
      get_destructor() {
        return _[this.ptr + 8 >> 2];
      }
      set_caught(t) {
        t = t ? 1 : 0, Y[this.ptr + 12] = t;
      }
      get_caught() {
        return Y[this.ptr + 12] != 0;
      }
      set_rethrown(t) {
        t = t ? 1 : 0, Y[this.ptr + 13] = t;
      }
      get_rethrown() {
        return Y[this.ptr + 13] != 0;
      }
      init(t, r) {
        this.set_adjusted_ptr(0), this.set_type(t), this.set_destructor(r);
      }
      set_adjusted_ptr(t) {
        _[this.ptr + 16 >> 2] = t;
      }
      get_adjusted_ptr() {
        return _[this.ptr + 16 >> 2];
      }
      get_exception_ptr() {
        var t = Ye(this.get_type());
        if (t)
          return _[this.excPtr >> 2];
        var r = this.get_adjusted_ptr();
        return r !== 0 ? r : this.excPtr;
      }
    }
    var Dr = (e) => {
      throw q || (q = e), q;
    }, Yt = (e) => {
      var t = q;
      if (!t)
        return Ct(0), 0;
      var r = new Lt(t);
      r.set_adjusted_ptr(t);
      var n = r.get_type();
      if (!n)
        return Ct(0), t;
      for (var a in e) {
        var o = e[a];
        if (o === 0 || o === n)
          break;
        var s = r.ptr + 16;
        if (Le(o, n, s))
          return Ct(o), t;
      }
      return Ct(n), t;
    }, xr = () => Yt([]), Or = (e) => Yt([e]), Fr = (e, t) => Yt([e, t]), Mr = () => {
      var e = Pt.pop();
      e || Tt("no exception to throw");
      var t = e.excPtr;
      throw e.get_rethrown() || (Pt.push(e), e.set_rethrown(!0), e.set_caught(!1), Et++), q = t, q;
    }, Sr = (e, t, r) => {
      var n = new Lt(e);
      throw n.init(t, r), q = e, Et++, q;
    }, jr = () => Et, At = {}, zt = (e) => {
      for (; e.length; ) {
        var t = e.pop(), r = e.pop();
        r(t);
      }
    };
    function mt(e) {
      return this.fromWireType(_[e >> 2]);
    }
    var st = {}, rt = {}, Dt = {}, we, xt = (e) => {
      throw new we(e);
    }, nt = (e, t, r) => {
      e.forEach(function(u) {
        Dt[u] = t;
      });
      function n(u) {
        var l = r(u);
        l.length !== e.length && xt("Mismatched type converter count");
        for (var h = 0; h < e.length; ++h)
          N(e[h], l[h]);
      }
      var a = new Array(t.length), o = [], s = 0;
      t.forEach((u, l) => {
        rt.hasOwnProperty(u) ? a[l] = rt[u] : (o.push(u), st.hasOwnProperty(u) || (st[u] = []), st[u].push(() => {
          a[l] = rt[u], ++s, s === o.length && n(a);
        }));
      }), o.length === 0 && n(a);
    }, Ir = (e) => {
      var t = At[e];
      delete At[e];
      var r = t.rawConstructor, n = t.rawDestructor, a = t.fields, o = a.map((s) => s.getterReturnType).concat(a.map((s) => s.setterArgumentType));
      nt([e], o, (s) => {
        var u = {};
        return a.forEach((l, h) => {
          var p = l.fieldName, g = s[h], y = l.getter, b = l.getterContext, O = s[h + a.length], k = l.setter, P = l.setterContext;
          u[p] = {
            read: (j) => g.fromWireType(y(b, j)),
            write: (j, d) => {
              var m = [];
              k(P, j, O.toWireType(m, d)), zt(m);
            }
          };
        }), [{
          name: t.name,
          fromWireType: (l) => {
            var h = {};
            for (var p in u)
              h[p] = u[p].read(l);
            return n(l), h;
          },
          toWireType: (l, h) => {
            for (var p in u)
              if (!(p in h))
                throw new TypeError(`Missing field: "${p}"`);
            var g = r();
            for (p in u)
              u[p].write(g, h[p]);
            return l !== null && l.push(n, g), g;
          },
          argPackAdvance: G,
          readValueFromPointer: mt,
          destructorFunction: n
        }];
      });
    }, Wr = (e, t, r, n, a) => {
    }, Rr = () => {
      for (var e = new Array(256), t = 0; t < 256; ++t)
        e[t] = String.fromCharCode(t);
      $e = e;
    }, $e, I = (e) => {
      for (var t = "", r = e; W[r]; )
        t += $e[W[r++]];
      return t;
    }, ut, C = (e) => {
      throw new ut(e);
    };
    function kr(e, t) {
      let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var n = t.name;
      if (e || C(`type "${n}" must have a positive integer typeid pointer`), rt.hasOwnProperty(e)) {
        if (r.ignoreDuplicateRegistrations)
          return;
        C(`Cannot register type '${n}' twice`);
      }
      if (rt[e] = t, delete Dt[e], st.hasOwnProperty(e)) {
        var a = st[e];
        delete st[e], a.forEach((o) => o());
      }
    }
    function N(e, t) {
      let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (!("argPackAdvance" in t))
        throw new TypeError("registerType registeredInstance requires argPackAdvance");
      return kr(e, t, r);
    }
    var G = 8, Hr = (e, t, r, n) => {
      t = I(t), N(e, {
        name: t,
        fromWireType: function(a) {
          return !!a;
        },
        toWireType: function(a, o) {
          return o ? r : n;
        },
        argPackAdvance: G,
        readValueFromPointer: function(a) {
          return this.fromWireType(W[a]);
        },
        destructorFunction: null
      });
    }, Br = (e) => ({
      count: e.count,
      deleteScheduled: e.deleteScheduled,
      preservePointerOnDelete: e.preservePointerOnDelete,
      ptr: e.ptr,
      ptrType: e.ptrType,
      smartPtr: e.smartPtr,
      smartPtrType: e.smartPtrType
    }), Nt = (e) => {
      function t(r) {
        return r.$$.ptrType.registeredClass.name;
      }
      C(t(e) + " instance already deleted");
    }, Gt = !1, be = (e) => {
    }, Ur = (e) => {
      e.smartPtr ? e.smartPtrType.rawDestructor(e.smartPtr) : e.ptrType.registeredClass.rawDestructor(e.ptr);
    }, Ce = (e) => {
      e.count.value -= 1;
      var t = e.count.value === 0;
      t && Ur(e);
    }, _e = (e, t, r) => {
      if (t === r)
        return e;
      if (r.baseClass === void 0)
        return null;
      var n = _e(e, t, r.baseClass);
      return n === null ? null : r.downcast(n);
    }, Te = {}, Vr = () => Object.keys(gt).length, Lr = () => {
      var e = [];
      for (var t in gt)
        gt.hasOwnProperty(t) && e.push(gt[t]);
      return e;
    }, yt = [], Xt = () => {
      for (; yt.length; ) {
        var e = yt.pop();
        e.$$.deleteScheduled = !1, e.delete();
      }
    }, vt, Yr = (e) => {
      vt = e, yt.length && vt && vt(Xt);
    }, zr = () => {
      c.getInheritedInstanceCount = Vr, c.getLiveInheritedInstances = Lr, c.flushPendingDeletes = Xt, c.setDelayFunction = Yr;
    }, gt = {}, Nr = (e, t) => {
      for (t === void 0 && C("ptr should not be undefined"); e.baseClass; )
        t = e.upcast(t), e = e.baseClass;
      return t;
    }, Gr = (e, t) => (t = Nr(e, t), gt[t]), Ot = (e, t) => {
      (!t.ptrType || !t.ptr) && xt("makeClassHandle requires ptr and ptrType");
      var r = !!t.smartPtrType, n = !!t.smartPtr;
      return r !== n && xt("Both smartPtrType and smartPtr must be specified"), t.count = {
        value: 1
      }, wt(Object.create(e, {
        $$: {
          value: t,
          writable: !0
        }
      }));
    };
    function Xr(e) {
      var t = this.getPointee(e);
      if (!t)
        return this.destructor(e), null;
      var r = Gr(this.registeredClass, t);
      if (r !== void 0) {
        if (r.$$.count.value === 0)
          return r.$$.ptr = t, r.$$.smartPtr = e, r.clone();
        var n = r.clone();
        return this.destructor(e), n;
      }
      function a() {
        return this.isSmartPointer ? Ot(this.registeredClass.instancePrototype, {
          ptrType: this.pointeeType,
          ptr: t,
          smartPtrType: this,
          smartPtr: e
        }) : Ot(this.registeredClass.instancePrototype, {
          ptrType: this,
          ptr: e
        });
      }
      var o = this.registeredClass.getActualType(t), s = Te[o];
      if (!s)
        return a.call(this);
      var u;
      this.isConst ? u = s.constPointerType : u = s.pointerType;
      var l = _e(t, this.registeredClass, u.registeredClass);
      return l === null ? a.call(this) : this.isSmartPointer ? Ot(u.registeredClass.instancePrototype, {
        ptrType: u,
        ptr: l,
        smartPtrType: this,
        smartPtr: e
      }) : Ot(u.registeredClass.instancePrototype, {
        ptrType: u,
        ptr: l
      });
    }
    var wt = (e) => typeof FinalizationRegistry > "u" ? (wt = (t) => t, e) : (Gt = new FinalizationRegistry((t) => {
      Ce(t.$$);
    }), wt = (t) => {
      var r = t.$$, n = !!r.smartPtr;
      if (n) {
        var a = {
          $$: r
        };
        Gt.register(t, a, t);
      }
      return t;
    }, be = (t) => Gt.unregister(t), wt(e)), qr = () => {
      Object.assign(Ft.prototype, {
        isAliasOf(e) {
          if (!(this instanceof Ft) || !(e instanceof Ft))
            return !1;
          var t = this.$$.ptrType.registeredClass, r = this.$$.ptr;
          e.$$ = e.$$;
          for (var n = e.$$.ptrType.registeredClass, a = e.$$.ptr; t.baseClass; )
            r = t.upcast(r), t = t.baseClass;
          for (; n.baseClass; )
            a = n.upcast(a), n = n.baseClass;
          return t === n && r === a;
        },
        clone() {
          if (this.$$.ptr || Nt(this), this.$$.preservePointerOnDelete)
            return this.$$.count.value += 1, this;
          var e = wt(Object.create(Object.getPrototypeOf(this), {
            $$: {
              value: Br(this.$$)
            }
          }));
          return e.$$.count.value += 1, e.$$.deleteScheduled = !1, e;
        },
        delete() {
          this.$$.ptr || Nt(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && C("Object already scheduled for deletion"), be(this), Ce(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        },
        isDeleted() {
          return !this.$$.ptr;
        },
        deleteLater() {
          return this.$$.ptr || Nt(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && C("Object already scheduled for deletion"), yt.push(this), yt.length === 1 && vt && vt(Xt), this.$$.deleteScheduled = !0, this;
        }
      });
    };
    function Ft() {
    }
    var $t = (e, t) => Object.defineProperty(t, "name", {
      value: e
    }), Pe = (e, t, r) => {
      if (e[t].overloadTable === void 0) {
        var n = e[t];
        e[t] = function() {
          for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++)
            o[s] = arguments[s];
          return e[t].overloadTable.hasOwnProperty(o.length) || C(`Function '${r}' called with an invalid number of arguments (${o.length}) - expects one of (${e[t].overloadTable})!`), e[t].overloadTable[o.length].apply(this, o);
        }, e[t].overloadTable = [], e[t].overloadTable[n.argCount] = n;
      }
    }, qt = (e, t, r) => {
      c.hasOwnProperty(e) ? ((r === void 0 || c[e].overloadTable !== void 0 && c[e].overloadTable[r] !== void 0) && C(`Cannot register public name '${e}' twice`), Pe(c, e, e), c.hasOwnProperty(r) && C(`Cannot register multiple overloads of a function with the same number of arguments (${r})!`), c[e].overloadTable[r] = t) : (c[e] = t, r !== void 0 && (c[e].numArguments = r));
    }, Qr = 48, Zr = 57, Jr = (e) => {
      if (e === void 0)
        return "_unknown";
      e = e.replace(/[^a-zA-Z0-9_]/g, "$");
      var t = e.charCodeAt(0);
      return t >= Qr && t <= Zr ? `_${e}` : e;
    };
    function Kr(e, t, r, n, a, o, s, u) {
      this.name = e, this.constructor = t, this.instancePrototype = r, this.rawDestructor = n, this.baseClass = a, this.getActualType = o, this.upcast = s, this.downcast = u, this.pureVirtualFunctions = [];
    }
    var Qt = (e, t, r) => {
      for (; t !== r; )
        t.upcast || C(`Expected null or instance of ${r.name}, got an instance of ${t.name}`), e = t.upcast(e), t = t.baseClass;
      return e;
    };
    function tn(e, t) {
      if (t === null)
        return this.isReference && C(`null is not a valid ${this.name}`), 0;
      t.$$ || C(`Cannot pass "${re(t)}" as a ${this.name}`), t.$$.ptr || C(`Cannot pass deleted object as a pointer of type ${this.name}`);
      var r = t.$$.ptrType.registeredClass, n = Qt(t.$$.ptr, r, this.registeredClass);
      return n;
    }
    function en(e, t) {
      var r;
      if (t === null)
        return this.isReference && C(`null is not a valid ${this.name}`), this.isSmartPointer ? (r = this.rawConstructor(), e !== null && e.push(this.rawDestructor, r), r) : 0;
      (!t || !t.$$) && C(`Cannot pass "${re(t)}" as a ${this.name}`), t.$$.ptr || C(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && t.$$.ptrType.isConst && C(`Cannot convert argument of type ${t.$$.smartPtrType ? t.$$.smartPtrType.name : t.$$.ptrType.name} to parameter type ${this.name}`);
      var n = t.$$.ptrType.registeredClass;
      if (r = Qt(t.$$.ptr, n, this.registeredClass), this.isSmartPointer)
        switch (t.$$.smartPtr === void 0 && C("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
          case 0:
            t.$$.smartPtrType === this ? r = t.$$.smartPtr : C(`Cannot convert argument of type ${t.$$.smartPtrType ? t.$$.smartPtrType.name : t.$$.ptrType.name} to parameter type ${this.name}`);
            break;
          case 1:
            r = t.$$.smartPtr;
            break;
          case 2:
            if (t.$$.smartPtrType === this)
              r = t.$$.smartPtr;
            else {
              var a = t.clone();
              r = this.rawShare(r, Z.toHandle(() => a.delete())), e !== null && e.push(this.rawDestructor, r);
            }
            break;
          default:
            C("Unsupporting sharing policy");
        }
      return r;
    }
    function rn(e, t) {
      if (t === null)
        return this.isReference && C(`null is not a valid ${this.name}`), 0;
      t.$$ || C(`Cannot pass "${re(t)}" as a ${this.name}`), t.$$.ptr || C(`Cannot pass deleted object as a pointer of type ${this.name}`), t.$$.ptrType.isConst && C(`Cannot convert argument of type ${t.$$.ptrType.name} to parameter type ${this.name}`);
      var r = t.$$.ptrType.registeredClass, n = Qt(t.$$.ptr, r, this.registeredClass);
      return n;
    }
    var nn = () => {
      Object.assign(Mt.prototype, {
        getPointee(e) {
          return this.rawGetPointee && (e = this.rawGetPointee(e)), e;
        },
        destructor(e) {
          var t;
          (t = this.rawDestructor) === null || t === void 0 || t.call(this, e);
        },
        argPackAdvance: G,
        readValueFromPointer: mt,
        fromWireType: Xr
      });
    };
    function Mt(e, t, r, n, a, o, s, u, l, h, p) {
      this.name = e, this.registeredClass = t, this.isReference = r, this.isConst = n, this.isSmartPointer = a, this.pointeeType = o, this.sharingPolicy = s, this.rawGetPointee = u, this.rawConstructor = l, this.rawShare = h, this.rawDestructor = p, !a && t.baseClass === void 0 ? n ? (this.toWireType = tn, this.destructorFunction = null) : (this.toWireType = rn, this.destructorFunction = null) : this.toWireType = en;
    }
    var Ee = (e, t, r) => {
      c.hasOwnProperty(e) || xt("Replacing nonexistant public symbol"), c[e].overloadTable !== void 0 && r !== void 0 ? c[e].overloadTable[r] = t : (c[e] = t, c[e].argCount = r);
    }, an = (e, t, r) => {
      var n = c["dynCall_" + e];
      return n(t, ...r);
    }, St = [], Ae, E = (e) => {
      var t = St[e];
      return t || (e >= St.length && (St.length = e + 1), St[e] = t = Ae.get(e)), t;
    }, on = function(e, t) {
      let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (e.includes("j"))
        return an(e, t, r);
      var n = E(t)(...r);
      return n;
    }, sn = (e, t) => function() {
      for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
        n[a] = arguments[a];
      return on(e, t, n);
    }, z = (e, t) => {
      e = I(e);
      function r() {
        return e.includes("j") ? sn(e, t) : E(t);
      }
      var n = r();
      return typeof n != "function" && C(`unknown function pointer with signature ${e}: ${t}`), n;
    }, un = (e, t) => {
      var r = $t(t, function(n) {
        this.name = t, this.message = n;
        var a = new Error(n).stack;
        a !== void 0 && (this.stack = this.toString() + `
` + a.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, r;
    }, De, xe = (e) => {
      var t = Be(e), r = I(t);
      return J(t), r;
    }, jt = (e, t) => {
      var r = [], n = {};
      function a(o) {
        if (!n[o] && !rt[o]) {
          if (Dt[o]) {
            Dt[o].forEach(a);
            return;
          }
          r.push(o), n[o] = !0;
        }
      }
      throw t.forEach(a), new De(`${e}: ` + r.map(xe).join([", "]));
    }, cn = (e, t, r, n, a, o, s, u, l, h, p, g, y) => {
      p = I(p), o = z(a, o), u && (u = z(s, u)), h && (h = z(l, h)), y = z(g, y);
      var b = Jr(p);
      qt(b, function() {
        jt(`Cannot construct ${p} due to unbound types`, [n]);
      }), nt([e, t, r], n ? [n] : [], (O) => {
        O = O[0];
        var k, P;
        n ? (k = O.registeredClass, P = k.instancePrototype) : P = Ft.prototype;
        var j = $t(p, function() {
          if (Object.getPrototypeOf(this) !== d)
            throw new ut("Use 'new' to construct " + p);
          if (m.constructor_body === void 0)
            throw new ut(p + " has no accessible constructor");
          for (var Xe = arguments.length, kt = new Array(Xe), Ht = 0; Ht < Xe; Ht++)
            kt[Ht] = arguments[Ht];
          var qe = m.constructor_body[kt.length];
          if (qe === void 0)
            throw new ut(`Tried to invoke ctor of ${p} with invalid number of parameters (${kt.length}) - expected (${Object.keys(m.constructor_body).toString()}) parameters instead!`);
          return qe.apply(this, kt);
        }), d = Object.create(P, {
          constructor: {
            value: j
          }
        });
        j.prototype = d;
        var m = new Kr(p, j, d, y, k, o, u, h);
        if (m.baseClass) {
          var F, S;
          (S = (F = m.baseClass).__derivedClasses) !== null && S !== void 0 || (F.__derivedClasses = []), m.baseClass.__derivedClasses.push(m);
        }
        var ct = new Mt(p, m, !0, !1, !1), Rt = new Mt(p + "*", m, !1, !1, !1), Ge = new Mt(p + " const*", m, !1, !0, !1);
        return Te[e] = {
          pointerType: Rt,
          constPointerType: Ge
        }, Ee(b, j), [ct, Rt, Ge];
      });
    }, Zt = (e, t) => {
      for (var r = [], n = 0; n < e; n++)
        r.push(_[t + n * 4 >> 2]);
      return r;
    };
    function ln(e) {
      for (var t = 1; t < e.length; ++t)
        if (e[t] !== null && e[t].destructorFunction === void 0)
          return !0;
      return !1;
    }
    function Jt(e, t, r, n, a, o) {
      var s = t.length;
      s < 2 && C("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var u = t[1] !== null && r !== null, l = ln(t), h = t[0].name !== "void", p = s - 2, g = new Array(p), y = [], b = [], O = function() {
        arguments.length !== p && C(`function ${e} called with ${arguments.length} arguments, expected ${p}`), b.length = 0;
        var k;
        y.length = u ? 2 : 1, y[0] = a, u && (k = t[1].toWireType(b, this), y[1] = k);
        for (var P = 0; P < p; ++P)
          g[P] = t[P + 2].toWireType(b, P < 0 || arguments.length <= P ? void 0 : arguments[P]), y.push(g[P]);
        var j = n(...y);
        function d(m) {
          if (l)
            zt(b);
          else
            for (var F = u ? 1 : 2; F < t.length; F++) {
              var S = F === 1 ? k : g[F - 2];
              t[F].destructorFunction !== null && t[F].destructorFunction(S);
            }
          if (h)
            return t[0].fromWireType(m);
        }
        return d(j);
      };
      return $t(e, O);
    }
    var dn = (e, t, r, n, a, o) => {
      var s = Zt(t, r);
      a = z(n, a), nt([], [e], (u) => {
        u = u[0];
        var l = `constructor ${u.name}`;
        if (u.registeredClass.constructor_body === void 0 && (u.registeredClass.constructor_body = []), u.registeredClass.constructor_body[t - 1] !== void 0)
          throw new ut(`Cannot register multiple constructors with identical number of parameters (${t - 1}) for class '${u.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return u.registeredClass.constructor_body[t - 1] = () => {
          jt(`Cannot construct ${u.name} due to unbound types`, s);
        }, nt([], s, (h) => (h.splice(1, 0, null), u.registeredClass.constructor_body[t - 1] = Jt(l, h, null, a, o), [])), [];
      });
    }, Oe = (e) => {
      e = e.trim();
      const t = e.indexOf("(");
      return t !== -1 ? e.substr(0, t) : e;
    }, hn = (e, t, r, n, a, o, s, u, l) => {
      var h = Zt(r, n);
      t = I(t), t = Oe(t), o = z(a, o), nt([], [e], (p) => {
        p = p[0];
        var g = `${p.name}.${t}`;
        t.startsWith("@@") && (t = Symbol[t.substring(2)]), u && p.registeredClass.pureVirtualFunctions.push(t);
        function y() {
          jt(`Cannot call ${g} due to unbound types`, h);
        }
        var b = p.registeredClass.instancePrototype, O = b[t];
        return O === void 0 || O.overloadTable === void 0 && O.className !== p.name && O.argCount === r - 2 ? (y.argCount = r - 2, y.className = p.name, b[t] = y) : (Pe(b, t, g), b[t].overloadTable[r - 2] = y), nt([], h, (k) => {
          var P = Jt(g, k, p, o, s);
          return b[t].overloadTable === void 0 ? (P.argCount = r - 2, b[t] = P) : b[t].overloadTable[r - 2] = P, [];
        }), [];
      });
    }, Kt = [], Q = [], te = (e) => {
      e > 9 && --Q[e + 1] === 0 && (Q[e] = void 0, Kt.push(e));
    }, fn = () => Q.length / 2 - 5 - Kt.length, pn = () => {
      Q.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), c.count_emval_handles = fn;
    }, Z = {
      toValue: (e) => (e || C("Cannot use deleted val. handle = " + e), Q[e]),
      toHandle: (e) => {
        switch (e) {
          case void 0:
            return 2;
          case null:
            return 4;
          case !0:
            return 6;
          case !1:
            return 8;
          default: {
            const t = Kt.pop() || Q.length;
            return Q[t] = e, Q[t + 1] = 1, t;
          }
        }
      }
    }, mn = {
      name: "emscripten::val",
      fromWireType: (e) => {
        var t = Z.toValue(e);
        return te(e), t;
      },
      toWireType: (e, t) => Z.toHandle(t),
      argPackAdvance: G,
      readValueFromPointer: mt,
      destructorFunction: null
    }, Fe = (e) => N(e, mn), yn = (e, t, r) => {
      switch (t) {
        case 1:
          return r ? function(n) {
            return this.fromWireType(Y[n]);
          } : function(n) {
            return this.fromWireType(W[n]);
          };
        case 2:
          return r ? function(n) {
            return this.fromWireType(ot[n >> 1]);
          } : function(n) {
            return this.fromWireType(ft[n >> 1]);
          };
        case 4:
          return r ? function(n) {
            return this.fromWireType(R[n >> 2]);
          } : function(n) {
            return this.fromWireType(_[n >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${t}): ${e}`);
      }
    }, vn = (e, t, r, n) => {
      t = I(t);
      function a() {
      }
      a.values = {}, N(e, {
        name: t,
        constructor: a,
        fromWireType: function(o) {
          return this.constructor.values[o];
        },
        toWireType: (o, s) => s.value,
        argPackAdvance: G,
        readValueFromPointer: yn(t, r, n),
        destructorFunction: null
      }), qt(t, a);
    }, ee = (e, t) => {
      var r = rt[e];
      return r === void 0 && C(`${t} has unknown type ${xe(e)}`), r;
    }, gn = (e, t, r) => {
      var n = ee(e, "enum");
      t = I(t);
      var a = n.constructor, o = Object.create(n.constructor.prototype, {
        value: {
          value: r
        },
        constructor: {
          value: $t(`${n.name}_${t}`, function() {
          })
        }
      });
      a.values[r] = o, a[t] = o;
    }, re = (e) => {
      if (e === null)
        return "null";
      var t = typeof e;
      return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
    }, wn = (e, t) => {
      switch (t) {
        case 4:
          return function(r) {
            return this.fromWireType(le[r >> 2]);
          };
        case 8:
          return function(r) {
            return this.fromWireType(de[r >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${t}): ${e}`);
      }
    }, $n = (e, t, r) => {
      t = I(t), N(e, {
        name: t,
        fromWireType: (n) => n,
        toWireType: (n, a) => a,
        argPackAdvance: G,
        readValueFromPointer: wn(t, r),
        destructorFunction: null
      });
    }, bn = (e, t, r, n, a, o, s) => {
      var u = Zt(t, r);
      e = I(e), e = Oe(e), a = z(n, a), qt(e, function() {
        jt(`Cannot call ${e} due to unbound types`, u);
      }, t - 1), nt([], u, (l) => {
        var h = [l[0], null].concat(l.slice(1));
        return Ee(e, Jt(e, h, null, a, o), t - 1), [];
      });
    }, Cn = (e, t, r) => {
      switch (t) {
        case 1:
          return r ? (n) => Y[n] : (n) => W[n];
        case 2:
          return r ? (n) => ot[n >> 1] : (n) => ft[n >> 1];
        case 4:
          return r ? (n) => R[n >> 2] : (n) => _[n >> 2];
        default:
          throw new TypeError(`invalid integer width (${t}): ${e}`);
      }
    }, _n = (e, t, r, n, a) => {
      t = I(t);
      var o = (p) => p;
      if (n === 0) {
        var s = 32 - 8 * r;
        o = (p) => p << s >>> s;
      }
      var u = t.includes("unsigned"), l = (p, g) => {
      }, h;
      u ? h = function(p, g) {
        return l(g, this.name), g >>> 0;
      } : h = function(p, g) {
        return l(g, this.name), g;
      }, N(e, {
        name: t,
        fromWireType: o,
        toWireType: h,
        argPackAdvance: G,
        readValueFromPointer: Cn(t, r, n !== 0),
        destructorFunction: null
      });
    }, Tn = (e, t, r) => {
      var n = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], a = n[t];
      function o(s) {
        var u = _[s >> 2], l = _[s + 4 >> 2];
        return new a(Y.buffer, l, u);
      }
      r = I(r), N(e, {
        name: r,
        fromWireType: o,
        argPackAdvance: G,
        readValueFromPointer: o
      }, {
        ignoreDuplicateRegistrations: !0
      });
    }, Pn = (e, t) => {
      Fe(e);
    }, Me = (e, t, r, n) => {
      if (!(n > 0))
        return 0;
      for (var a = r, o = r + n - 1, s = 0; s < e.length; ++s) {
        var u = e.charCodeAt(s);
        if (u >= 55296 && u <= 57343) {
          var l = e.charCodeAt(++s);
          u = 65536 + ((u & 1023) << 10) | l & 1023;
        }
        if (u <= 127) {
          if (r >= o)
            break;
          t[r++] = u;
        } else if (u <= 2047) {
          if (r + 1 >= o)
            break;
          t[r++] = 192 | u >> 6, t[r++] = 128 | u & 63;
        } else if (u <= 65535) {
          if (r + 2 >= o)
            break;
          t[r++] = 224 | u >> 12, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | u & 63;
        } else {
          if (r + 3 >= o)
            break;
          t[r++] = 240 | u >> 18, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | u & 63;
        }
      }
      return t[r] = 0, r - a;
    }, En = (e, t, r) => Me(e, W, t, r), Se = (e) => {
      for (var t = 0, r = 0; r < e.length; ++r) {
        var n = e.charCodeAt(r);
        n <= 127 ? t++ : n <= 2047 ? t += 2 : n >= 55296 && n <= 57343 ? (t += 4, ++r) : t += 3;
      }
      return t;
    }, je = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Ie = (e, t, r) => {
      for (var n = t + r, a = t; e[a] && !(a >= n); )
        ++a;
      if (a - t > 16 && e.buffer && je)
        return je.decode(e.subarray(t, a));
      for (var o = ""; t < a; ) {
        var s = e[t++];
        if (!(s & 128)) {
          o += String.fromCharCode(s);
          continue;
        }
        var u = e[t++] & 63;
        if ((s & 224) == 192) {
          o += String.fromCharCode((s & 31) << 6 | u);
          continue;
        }
        var l = e[t++] & 63;
        if ((s & 240) == 224 ? s = (s & 15) << 12 | u << 6 | l : s = (s & 7) << 18 | u << 12 | l << 6 | e[t++] & 63, s < 65536)
          o += String.fromCharCode(s);
        else {
          var h = s - 65536;
          o += String.fromCharCode(55296 | h >> 10, 56320 | h & 1023);
        }
      }
      return o;
    }, ne = (e, t) => e ? Ie(W, e, t) : "", An = (e, t) => {
      t = I(t);
      var r = t === "std::string";
      N(e, {
        name: t,
        fromWireType(n) {
          var a = _[n >> 2], o = n + 4, s;
          if (r)
            for (var u = o, l = 0; l <= a; ++l) {
              var h = o + l;
              if (l == a || W[h] == 0) {
                var p = h - u, g = ne(u, p);
                s === void 0 ? s = g : (s += "\0", s += g), u = h + 1;
              }
            }
          else {
            for (var y = new Array(a), l = 0; l < a; ++l)
              y[l] = String.fromCharCode(W[o + l]);
            s = y.join("");
          }
          return J(n), s;
        },
        toWireType(n, a) {
          a instanceof ArrayBuffer && (a = new Uint8Array(a));
          var o, s = typeof a == "string";
          s || a instanceof Uint8Array || a instanceof Uint8ClampedArray || a instanceof Int8Array || C("Cannot pass non-string to std::string"), r && s ? o = Se(a) : o = a.length;
          var u = ie(4 + o + 1), l = u + 4;
          if (_[u >> 2] = o, r && s)
            En(a, l, o + 1);
          else if (s)
            for (var h = 0; h < o; ++h) {
              var p = a.charCodeAt(h);
              p > 255 && (J(l), C("String has UTF-16 code units that do not fit in 8 bits")), W[l + h] = p;
            }
          else
            for (var h = 0; h < o; ++h)
              W[l + h] = a[h];
          return n !== null && n.push(J, u), u;
        },
        argPackAdvance: G,
        readValueFromPointer: mt,
        destructorFunction(n) {
          J(n);
        }
      });
    }, We = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, Dn = (e, t) => {
      for (var r = e, n = r >> 1, a = n + t / 2; !(n >= a) && ft[n]; )
        ++n;
      if (r = n << 1, r - e > 32 && We)
        return We.decode(W.subarray(e, r));
      for (var o = "", s = 0; !(s >= t / 2); ++s) {
        var u = ot[e + s * 2 >> 1];
        if (u == 0)
          break;
        o += String.fromCharCode(u);
      }
      return o;
    }, xn = (e, t, r) => {
      var n;
      if ((n = r) !== null && n !== void 0 || (r = 2147483647), r < 2)
        return 0;
      r -= 2;
      for (var a = t, o = r < e.length * 2 ? r / 2 : e.length, s = 0; s < o; ++s) {
        var u = e.charCodeAt(s);
        ot[t >> 1] = u, t += 2;
      }
      return ot[t >> 1] = 0, t - a;
    }, On = (e) => e.length * 2, Fn = (e, t) => {
      for (var r = 0, n = ""; !(r >= t / 4); ) {
        var a = R[e + r * 4 >> 2];
        if (a == 0)
          break;
        if (++r, a >= 65536) {
          var o = a - 65536;
          n += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023);
        } else
          n += String.fromCharCode(a);
      }
      return n;
    }, Mn = (e, t, r) => {
      var n;
      if ((n = r) !== null && n !== void 0 || (r = 2147483647), r < 4)
        return 0;
      for (var a = t, o = a + r - 4, s = 0; s < e.length; ++s) {
        var u = e.charCodeAt(s);
        if (u >= 55296 && u <= 57343) {
          var l = e.charCodeAt(++s);
          u = 65536 + ((u & 1023) << 10) | l & 1023;
        }
        if (R[t >> 2] = u, t += 4, t + 4 > o)
          break;
      }
      return R[t >> 2] = 0, t - a;
    }, Sn = (e) => {
      for (var t = 0, r = 0; r < e.length; ++r) {
        var n = e.charCodeAt(r);
        n >= 55296 && n <= 57343 && ++r, t += 4;
      }
      return t;
    }, jn = (e, t, r) => {
      r = I(r);
      var n, a, o, s;
      t === 2 ? (n = Dn, a = xn, s = On, o = (u) => ft[u >> 1]) : t === 4 && (n = Fn, a = Mn, s = Sn, o = (u) => _[u >> 2]), N(e, {
        name: r,
        fromWireType: (u) => {
          for (var l = _[u >> 2], h, p = u + 4, g = 0; g <= l; ++g) {
            var y = u + 4 + g * t;
            if (g == l || o(y) == 0) {
              var b = y - p, O = n(p, b);
              h === void 0 ? h = O : (h += "\0", h += O), p = y + t;
            }
          }
          return J(u), h;
        },
        toWireType: (u, l) => {
          typeof l != "string" && C(`Cannot pass non-string to C++ string type ${r}`);
          var h = s(l), p = ie(4 + h + t);
          return _[p >> 2] = h / t, a(l, p + 4, h + t), u !== null && u.push(J, p), p;
        },
        argPackAdvance: G,
        readValueFromPointer: mt,
        destructorFunction(u) {
          J(u);
        }
      });
    }, In = (e, t, r, n, a, o) => {
      At[e] = {
        name: I(t),
        rawConstructor: z(r, n),
        rawDestructor: z(a, o),
        fields: []
      };
    }, Wn = (e, t, r, n, a, o, s, u, l, h) => {
      At[e].fields.push({
        fieldName: I(t),
        getterReturnType: r,
        getter: z(n, a),
        getterContext: o,
        setterArgumentType: s,
        setter: z(u, l),
        setterContext: h
      });
    }, Rn = (e, t) => {
      t = I(t), N(e, {
        isVoid: !0,
        name: t,
        argPackAdvance: 0,
        fromWireType: () => {
        },
        toWireType: (r, n) => {
        }
      });
    }, ae = [], kn = (e, t, r, n) => (e = ae[e], t = Z.toValue(t), e(null, t, r, n)), Hn = {}, Bn = (e) => {
      var t = Hn[e];
      return t === void 0 ? I(e) : t;
    }, Re = () => {
      if (typeof globalThis == "object")
        return globalThis;
      function e(t) {
        t.$$$embind_global$$$ = t;
        var r = typeof $$$embind_global$$$ == "object" && t.$$$embind_global$$$ == t;
        return r || delete t.$$$embind_global$$$, r;
      }
      if (typeof $$$embind_global$$$ == "object" || (typeof global == "object" && e(global) ? $$$embind_global$$$ = global : typeof self == "object" && e(self) && ($$$embind_global$$$ = self), typeof $$$embind_global$$$ == "object"))
        return $$$embind_global$$$;
      throw Error("unable to get global object.");
    }, Un = (e) => e === 0 ? Z.toHandle(Re()) : (e = Bn(e), Z.toHandle(Re()[e])), Vn = (e) => {
      var t = ae.length;
      return ae.push(e), t;
    }, Ln = (e, t) => {
      for (var r = new Array(e), n = 0; n < e; ++n)
        r[n] = ee(_[t + n * 4 >> 2], "parameter " + n);
      return r;
    }, Yn = Reflect.construct, zn = (e, t, r) => {
      var n = [], a = e.toWireType(n, r);
      return n.length && (_[t >> 2] = Z.toHandle(n)), a;
    }, Nn = (e, t, r) => {
      var n = Ln(e, t), a = n.shift();
      e--;
      var o = new Array(e), s = (l, h, p, g) => {
        for (var y = 0, b = 0; b < e; ++b)
          o[b] = n[b].readValueFromPointer(g + y), y += n[b].argPackAdvance;
        var O = r === 1 ? Yn(h, o) : h.apply(l, o);
        return zn(a, p, O);
      }, u = `methodCaller<(${n.map((l) => l.name).join(", ")}) => ${a.name}>`;
      return Vn($t(u, s));
    }, Gn = (e) => {
      e > 9 && (Q[e + 1] += 1);
    }, Xn = (e) => {
      var t = Z.toValue(e);
      zt(t), te(e);
    }, qn = (e, t) => {
      e = ee(e, "_emval_take_value");
      var r = e.readValueFromPointer(t);
      return Z.toHandle(r);
    }, Qn = () => {
      Tt("");
    }, Zn = (e, t, r) => W.copyWithin(e, t, t + r), Jn = () => 2147483648, Kn = (e) => {
      var t = at.buffer, r = (e - t.byteLength + 65535) / 65536;
      try {
        return at.grow(r), he(), 1;
      } catch {
      }
    }, ta = (e) => {
      var t = W.length;
      e >>>= 0;
      var r = Jn();
      if (e > r)
        return !1;
      for (var n = (l, h) => l + (h - l % h) % h, a = 1; a <= 4; a *= 2) {
        var o = t * (1 + 0.2 / a);
        o = Math.min(o, e + 100663296);
        var s = Math.min(r, n(Math.max(e, o), 65536)), u = Kn(s);
        if (u)
          return !0;
      }
      return !1;
    }, oe = {}, ea = () => B || "./this.program", bt = () => {
      if (!bt.strings) {
        var e = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", t = {
          USER: "web_user",
          LOGNAME: "web_user",
          PATH: "/",
          PWD: "/",
          HOME: "/home/web_user",
          LANG: e,
          _: ea()
        };
        for (var r in oe)
          oe[r] === void 0 ? delete t[r] : t[r] = oe[r];
        var n = [];
        for (var r in t)
          n.push(`${r}=${t[r]}`);
        bt.strings = n;
      }
      return bt.strings;
    }, ra = (e, t) => {
      for (var r = 0; r < e.length; ++r)
        Y[t++] = e.charCodeAt(r);
      Y[t] = 0;
    }, na = (e, t) => {
      var r = 0;
      return bt().forEach((n, a) => {
        var o = t + r;
        _[e + a * 4 >> 2] = o, ra(n, o), r += n.length + 1;
      }), 0;
    }, aa = (e, t) => {
      var r = bt();
      _[e >> 2] = r.length;
      var n = 0;
      return r.forEach((a) => n += a.length + 1), _[t >> 2] = n, 0;
    }, oa = (e) => 52;
    function ia(e, t, r, n, a) {
      return 70;
    }
    var sa = [null, [], []], ua = (e, t) => {
      var r = sa[e];
      t === 0 || t === 10 ? ((e === 1 ? ht : X)(Ie(r, 0)), r.length = 0) : r.push(t);
    }, ca = (e, t, r, n) => {
      for (var a = 0, o = 0; o < r; o++) {
        var s = _[t >> 2], u = _[t + 4 >> 2];
        t += 8;
        for (var l = 0; l < u; l++)
          ua(e, W[s + l]);
        a += u;
      }
      return _[n >> 2] = a, 0;
    }, la = (e) => e, It = (e) => e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0), da = (e, t) => {
      for (var r = 0, n = 0; n <= t; r += e[n++])
        ;
      return r;
    }, ke = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], He = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ha = (e, t) => {
      for (var r = new Date(e.getTime()); t > 0; ) {
        var n = It(r.getFullYear()), a = r.getMonth(), o = (n ? ke : He)[a];
        if (t > o - r.getDate())
          t -= o - r.getDate() + 1, r.setDate(1), a < 11 ? r.setMonth(a + 1) : (r.setMonth(0), r.setFullYear(r.getFullYear() + 1));
        else
          return r.setDate(r.getDate() + t), r;
      }
      return r;
    };
    function fa(e, t, r) {
      var n = r > 0 ? r : Se(e) + 1, a = new Array(n), o = Me(e, a, 0, a.length);
      return t && (a.length = o), a;
    }
    var pa = (e, t) => {
      Y.set(e, t);
    }, ma = (e, t, r, n) => {
      var a = _[n + 40 >> 2], o = {
        tm_sec: R[n >> 2],
        tm_min: R[n + 4 >> 2],
        tm_hour: R[n + 8 >> 2],
        tm_mday: R[n + 12 >> 2],
        tm_mon: R[n + 16 >> 2],
        tm_year: R[n + 20 >> 2],
        tm_wday: R[n + 24 >> 2],
        tm_yday: R[n + 28 >> 2],
        tm_isdst: R[n + 32 >> 2],
        tm_gmtoff: R[n + 36 >> 2],
        tm_zone: a ? ne(a) : ""
      }, s = ne(r), u = {
        "%c": "%a %b %d %H:%M:%S %Y",
        "%D": "%m/%d/%y",
        "%F": "%Y-%m-%d",
        "%h": "%b",
        "%r": "%I:%M:%S %p",
        "%R": "%H:%M",
        "%T": "%H:%M:%S",
        "%x": "%m/%d/%y",
        "%X": "%H:%M:%S",
        "%Ec": "%c",
        "%EC": "%C",
        "%Ex": "%m/%d/%y",
        "%EX": "%H:%M:%S",
        "%Ey": "%y",
        "%EY": "%Y",
        "%Od": "%d",
        "%Oe": "%e",
        "%OH": "%H",
        "%OI": "%I",
        "%Om": "%m",
        "%OM": "%M",
        "%OS": "%S",
        "%Ou": "%u",
        "%OU": "%U",
        "%OV": "%V",
        "%Ow": "%w",
        "%OW": "%W",
        "%Oy": "%y"
      };
      for (var l in u)
        s = s.replace(new RegExp(l, "g"), u[l]);
      var h = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], p = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      function g(d, m, F) {
        for (var S = typeof d == "number" ? d.toString() : d || ""; S.length < m; )
          S = F[0] + S;
        return S;
      }
      function y(d, m) {
        return g(d, m, "0");
      }
      function b(d, m) {
        function F(ct) {
          return ct < 0 ? -1 : ct > 0 ? 1 : 0;
        }
        var S;
        return (S = F(d.getFullYear() - m.getFullYear())) === 0 && (S = F(d.getMonth() - m.getMonth())) === 0 && (S = F(d.getDate() - m.getDate())), S;
      }
      function O(d) {
        switch (d.getDay()) {
          case 0:
            return new Date(d.getFullYear() - 1, 11, 29);
          case 1:
            return d;
          case 2:
            return new Date(d.getFullYear(), 0, 3);
          case 3:
            return new Date(d.getFullYear(), 0, 2);
          case 4:
            return new Date(d.getFullYear(), 0, 1);
          case 5:
            return new Date(d.getFullYear() - 1, 11, 31);
          case 6:
            return new Date(d.getFullYear() - 1, 11, 30);
        }
      }
      function k(d) {
        var m = ha(new Date(d.tm_year + 1900, 0, 1), d.tm_yday), F = new Date(m.getFullYear(), 0, 4), S = new Date(m.getFullYear() + 1, 0, 4), ct = O(F), Rt = O(S);
        return b(ct, m) <= 0 ? b(Rt, m) <= 0 ? m.getFullYear() + 1 : m.getFullYear() : m.getFullYear() - 1;
      }
      var P = {
        "%a": (d) => h[d.tm_wday].substring(0, 3),
        "%A": (d) => h[d.tm_wday],
        "%b": (d) => p[d.tm_mon].substring(0, 3),
        "%B": (d) => p[d.tm_mon],
        "%C": (d) => {
          var m = d.tm_year + 1900;
          return y(m / 100 | 0, 2);
        },
        "%d": (d) => y(d.tm_mday, 2),
        "%e": (d) => g(d.tm_mday, 2, " "),
        "%g": (d) => k(d).toString().substring(2),
        "%G": k,
        "%H": (d) => y(d.tm_hour, 2),
        "%I": (d) => {
          var m = d.tm_hour;
          return m == 0 ? m = 12 : m > 12 && (m -= 12), y(m, 2);
        },
        "%j": (d) => y(d.tm_mday + da(It(d.tm_year + 1900) ? ke : He, d.tm_mon - 1), 3),
        "%m": (d) => y(d.tm_mon + 1, 2),
        "%M": (d) => y(d.tm_min, 2),
        "%n": () => `
`,
        "%p": (d) => d.tm_hour >= 0 && d.tm_hour < 12 ? "AM" : "PM",
        "%S": (d) => y(d.tm_sec, 2),
        "%t": () => "	",
        "%u": (d) => d.tm_wday || 7,
        "%U": (d) => {
          var m = d.tm_yday + 7 - d.tm_wday;
          return y(Math.floor(m / 7), 2);
        },
        "%V": (d) => {
          var m = Math.floor((d.tm_yday + 7 - (d.tm_wday + 6) % 7) / 7);
          if ((d.tm_wday + 371 - d.tm_yday - 2) % 7 <= 2 && m++, m) {
            if (m == 53) {
              var F = (d.tm_wday + 371 - d.tm_yday) % 7;
              F != 4 && (F != 3 || !It(d.tm_year)) && (m = 1);
            }
          } else {
            m = 52;
            var S = (d.tm_wday + 7 - d.tm_yday - 1) % 7;
            (S == 4 || S == 5 && It(d.tm_year % 400 - 1)) && m++;
          }
          return y(m, 2);
        },
        "%w": (d) => d.tm_wday,
        "%W": (d) => {
          var m = d.tm_yday + 7 - (d.tm_wday + 6) % 7;
          return y(Math.floor(m / 7), 2);
        },
        "%y": (d) => (d.tm_year + 1900).toString().substring(2),
        "%Y": (d) => d.tm_year + 1900,
        "%z": (d) => {
          var m = d.tm_gmtoff, F = m >= 0;
          return m = Math.abs(m) / 60, m = m / 60 * 100 + m % 60, (F ? "+" : "-") + ("0000" + m).slice(-4);
        },
        "%Z": (d) => d.tm_zone,
        "%%": () => "%"
      };
      s = s.replace(/%%/g, "\0\0");
      for (var l in P)
        s.includes(l) && (s = s.replace(new RegExp(l, "g"), P[l](o)));
      s = s.replace(/\0\0/g, "%");
      var j = fa(s, !1);
      return j.length > t ? 0 : (pa(j, e), j.length - 1);
    }, ya = (e, t, r, n, a) => ma(e, t, r, n);
    we = c.InternalError = class extends Error {
      constructor(e) {
        super(e), this.name = "InternalError";
      }
    }, Rr(), ut = c.BindingError = class extends Error {
      constructor(e) {
        super(e), this.name = "BindingError";
      }
    }, qr(), zr(), nn(), De = c.UnboundTypeError = un(Error, "UnboundTypeError"), pn();
    var va = {
      s: Er,
      u: Ar,
      b: xr,
      g: Or,
      q: Fr,
      K: Mr,
      f: Sr,
      Y: jr,
      d: Dr,
      ha: Ir,
      U: Wr,
      ba: Hr,
      fa: cn,
      ea: dn,
      w: hn,
      aa: Fe,
      x: vn,
      h: gn,
      O: $n,
      P: bn,
      t: _n,
      o: Tn,
      ga: Pn,
      N: An,
      C: jn,
      A: In,
      ia: Wn,
      ca: Rn,
      E: kn,
      ka: te,
      la: Un,
      M: Nn,
      Q: Gn,
      R: Xn,
      da: qn,
      B: Qn,
      $: Zn,
      Z: ta,
      W: na,
      X: aa,
      _: oa,
      T: ia,
      L: ca,
      F: Sa,
      D: Ca,
      G: Ma,
      m: ja,
      a: ga,
      e: Ta,
      p: ba,
      k: Fa,
      I: xa,
      v: Aa,
      H: Oa,
      z: Wa,
      S: ka,
      l: Pa,
      j: _a,
      c: $a,
      n: wa,
      J: Da,
      r: Ia,
      i: Ea,
      y: Ra,
      ja: la,
      V: ya
    }, A = Pr(), J = c._free = (e) => (J = c._free = A.oa)(e), ie = c._malloc = (e) => (ie = c._malloc = A.pa)(e), Be = (e) => (Be = A.ra)(e), T = (e, t) => (T = A.sa)(e, t), Ct = (e) => (Ct = A.ta)(e), D = () => (D = A.ua)(), x = (e) => (x = A.va)(e), Ue = (e) => (Ue = A.wa)(e), Ve = (e) => (Ve = A.xa)(e), Le = (e, t, r) => (Le = A.ya)(e, t, r), Ye = (e) => (Ye = A.za)(e);
    c.dynCall_viijii = (e, t, r, n, a, o, s) => (c.dynCall_viijii = A.Aa)(e, t, r, n, a, o, s), c.dynCall_jiji = (e, t, r, n, a) => (c.dynCall_jiji = A.Ba)(e, t, r, n, a);
    var ze = c.dynCall_jiiii = (e, t, r, n, a) => (ze = c.dynCall_jiiii = A.Ca)(e, t, r, n, a);
    c.dynCall_iiiiij = (e, t, r, n, a, o, s) => (c.dynCall_iiiiij = A.Da)(e, t, r, n, a, o, s), c.dynCall_iiiiijj = (e, t, r, n, a, o, s, u, l) => (c.dynCall_iiiiijj = A.Ea)(e, t, r, n, a, o, s, u, l), c.dynCall_iiiiiijj = (e, t, r, n, a, o, s, u, l, h) => (c.dynCall_iiiiiijj = A.Fa)(e, t, r, n, a, o, s, u, l, h);
    function ga(e, t) {
      var r = D();
      try {
        return E(e)(t);
      } catch (n) {
        if (x(r), n !== n + 0)
          throw n;
        T(1, 0);
      }
    }
    function wa(e, t, r, n) {
      var a = D();
      try {
        E(e)(t, r, n);
      } catch (o) {
        if (x(a), o !== o + 0)
          throw o;
        T(1, 0);
      }
    }
    function $a(e, t, r) {
      var n = D();
      try {
        E(e)(t, r);
      } catch (a) {
        if (x(n), a !== a + 0)
          throw a;
        T(1, 0);
      }
    }
    function ba(e, t, r, n) {
      var a = D();
      try {
        return E(e)(t, r, n);
      } catch (o) {
        if (x(a), o !== o + 0)
          throw o;
        T(1, 0);
      }
    }
    function Ca(e, t, r, n, a) {
      var o = D();
      try {
        return E(e)(t, r, n, a);
      } catch (s) {
        if (x(o), s !== s + 0)
          throw s;
        T(1, 0);
      }
    }
    function _a(e, t) {
      var r = D();
      try {
        E(e)(t);
      } catch (n) {
        if (x(r), n !== n + 0)
          throw n;
        T(1, 0);
      }
    }
    function Ta(e, t, r) {
      var n = D();
      try {
        return E(e)(t, r);
      } catch (a) {
        if (x(n), a !== a + 0)
          throw a;
        T(1, 0);
      }
    }
    function Pa(e) {
      var t = D();
      try {
        E(e)();
      } catch (r) {
        if (x(t), r !== r + 0)
          throw r;
        T(1, 0);
      }
    }
    function Ea(e, t, r, n, a, o, s, u, l, h, p) {
      var g = D();
      try {
        E(e)(t, r, n, a, o, s, u, l, h, p);
      } catch (y) {
        if (x(g), y !== y + 0)
          throw y;
        T(1, 0);
      }
    }
    function Aa(e, t, r, n, a, o, s) {
      var u = D();
      try {
        return E(e)(t, r, n, a, o, s);
      } catch (l) {
        if (x(u), l !== l + 0)
          throw l;
        T(1, 0);
      }
    }
    function Da(e, t, r, n, a) {
      var o = D();
      try {
        E(e)(t, r, n, a);
      } catch (s) {
        if (x(o), s !== s + 0)
          throw s;
        T(1, 0);
      }
    }
    function xa(e, t, r, n, a, o) {
      var s = D();
      try {
        return E(e)(t, r, n, a, o);
      } catch (u) {
        if (x(s), u !== u + 0)
          throw u;
        T(1, 0);
      }
    }
    function Oa(e, t, r, n, a, o, s, u) {
      var l = D();
      try {
        return E(e)(t, r, n, a, o, s, u);
      } catch (h) {
        if (x(l), h !== h + 0)
          throw h;
        T(1, 0);
      }
    }
    function Fa(e, t, r, n, a) {
      var o = D();
      try {
        return E(e)(t, r, n, a);
      } catch (s) {
        if (x(o), s !== s + 0)
          throw s;
        T(1, 0);
      }
    }
    function Ma(e, t, r, n) {
      var a = D();
      try {
        return E(e)(t, r, n);
      } catch (o) {
        if (x(a), o !== o + 0)
          throw o;
        T(1, 0);
      }
    }
    function Sa(e, t, r, n) {
      var a = D();
      try {
        return E(e)(t, r, n);
      } catch (o) {
        if (x(a), o !== o + 0)
          throw o;
        T(1, 0);
      }
    }
    function ja(e) {
      var t = D();
      try {
        return E(e)();
      } catch (r) {
        if (x(t), r !== r + 0)
          throw r;
        T(1, 0);
      }
    }
    function Ia(e, t, r, n, a, o, s, u) {
      var l = D();
      try {
        E(e)(t, r, n, a, o, s, u);
      } catch (h) {
        if (x(l), h !== h + 0)
          throw h;
        T(1, 0);
      }
    }
    function Wa(e, t, r, n, a, o, s, u, l, h, p, g) {
      var y = D();
      try {
        return E(e)(t, r, n, a, o, s, u, l, h, p, g);
      } catch (b) {
        if (x(y), b !== b + 0)
          throw b;
        T(1, 0);
      }
    }
    function Ra(e, t, r, n, a, o, s, u, l, h, p, g, y, b, O, k) {
      var P = D();
      try {
        E(e)(t, r, n, a, o, s, u, l, h, p, g, y, b, O, k);
      } catch (j) {
        if (x(P), j !== j + 0)
          throw j;
        T(1, 0);
      }
    }
    function ka(e, t, r, n, a) {
      var o = D();
      try {
        return ze(e, t, r, n, a);
      } catch (s) {
        if (x(o), s !== s + 0)
          throw s;
        T(1, 0);
      }
    }
    var Wt;
    pt = function e() {
      Wt || Ne(), Wt || (pt = e);
    };
    function Ne() {
      if (et > 0 || (pr(), et > 0))
        return;
      function e() {
        Wt || (Wt = !0, c.calledRun = !0, !_t && (mr(), w(c), c.onRuntimeInitialized && c.onRuntimeInitialized(), yr()));
      }
      c.setStatus ? (c.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          c.setStatus("");
        }, 1), e();
      }, 1)) : e();
    }
    if (c.preInit)
      for (typeof c.preInit == "function" && (c.preInit = [c.preInit]); c.preInit.length > 0; )
        c.preInit.pop()();
    return Ne(), f.ready;
  };
})();
function Za(i) {
  return ce(
    Ut,
    i
  );
}
function mo(i) {
  return Xa(
    Ut,
    i
  );
}
async function Ja(i, f) {
  return qa(
    Ut,
    i,
    f
  );
}
async function Ka(i, f) {
  return Qa(
    Ut,
    i,
    f
  );
}
const ar = [
  ["aztec", "Aztec"],
  ["code_128", "Code128"],
  ["code_39", "Code39"],
  ["code_93", "Code93"],
  ["codabar", "Codabar"],
  ["databar", "DataBar"],
  ["databar_expanded", "DataBarExpanded"],
  ["data_matrix", "DataMatrix"],
  ["dx_film_edge", "DXFilmEdge"],
  ["ean_13", "EAN-13"],
  ["ean_8", "EAN-8"],
  ["itf", "ITF"],
  ["maxi_code", "MaxiCode"],
  ["micro_qr_code", "MicroQRCode"],
  ["pdf417", "PDF417"],
  ["qr_code", "QRCode"],
  ["rm_qr_code", "rMQRCode"],
  ["upc_a", "UPC-A"],
  ["upc_e", "UPC-E"],
  ["linear_codes", "Linear-Codes"],
  ["matrix_codes", "Matrix-Codes"]
], to = [...ar, ["unknown"]].map((i) => i[0]), Bt = new Map(
  ar
);
function eo(i) {
  for (const [f, c] of Bt)
    if (i === c)
      return f;
  return "unknown";
}
function ro(i) {
  if (or(i))
    return {
      width: i.naturalWidth,
      height: i.naturalHeight
    };
  if (ir(i))
    return {
      width: i.width.baseVal.value,
      height: i.height.baseVal.value
    };
  if (sr(i))
    return {
      width: i.videoWidth,
      height: i.videoHeight
    };
  if (cr(i))
    return {
      width: i.width,
      height: i.height
    };
  if (dr(i))
    return {
      width: i.displayWidth,
      height: i.displayHeight
    };
  if (ur(i))
    return {
      width: i.width,
      height: i.height
    };
  if (lr(i))
    return {
      width: i.width,
      height: i.height
    };
  throw new TypeError(
    "The provided value is not of type '(Blob or HTMLCanvasElement or HTMLImageElement or HTMLVideoElement or ImageBitmap or ImageData or OffscreenCanvas or SVGImageElement or VideoFrame)'."
  );
}
function or(i) {
  try {
    return i instanceof HTMLImageElement;
  } catch {
    return !1;
  }
}
function ir(i) {
  try {
    return i instanceof SVGImageElement;
  } catch {
    return !1;
  }
}
function sr(i) {
  try {
    return i instanceof HTMLVideoElement;
  } catch {
    return !1;
  }
}
function ur(i) {
  try {
    return i instanceof HTMLCanvasElement;
  } catch {
    return !1;
  }
}
function cr(i) {
  try {
    return i instanceof ImageBitmap;
  } catch {
    return !1;
  }
}
function lr(i) {
  try {
    return i instanceof OffscreenCanvas;
  } catch {
    return !1;
  }
}
function dr(i) {
  try {
    return i instanceof VideoFrame;
  } catch {
    return !1;
  }
}
function hr(i) {
  try {
    return i instanceof Blob;
  } catch {
    return !1;
  }
}
function no(i) {
  try {
    return i instanceof ImageData;
  } catch {
    return !1;
  }
}
function ao(i, f) {
  try {
    const c = new OffscreenCanvas(i, f);
    if (c.getContext("2d") instanceof OffscreenCanvasRenderingContext2D)
      return c;
    throw void 0;
  } catch {
    const c = document.createElement("canvas");
    return c.width = i, c.height = f, c;
  }
}
async function fr(i) {
  if (or(i) && !await uo(i))
    throw new DOMException(
      "Failed to load or decode HTMLImageElement.",
      "InvalidStateError"
    );
  if (ir(i) && !await co(i))
    throw new DOMException(
      "Failed to load or decode SVGImageElement.",
      "InvalidStateError"
    );
  if (dr(i) && lo(i))
    throw new DOMException("VideoFrame is closed.", "InvalidStateError");
  if (sr(i) && (i.readyState === 0 || i.readyState === 1))
    throw new DOMException("Invalid element or state.", "InvalidStateError");
  if (cr(i) && fo(i))
    throw new DOMException(
      "The image source is detached.",
      "InvalidStateError"
    );
  const { width: f, height: c } = ro(i);
  if (f === 0 || c === 0)
    return null;
  const v = ao(f, c).getContext("2d");
  v.drawImage(i, 0, 0);
  try {
    return v.getImageData(0, 0, f, c);
  } catch {
    throw new DOMException("Source would taint origin.", "SecurityError");
  }
}
async function oo(i) {
  let f;
  try {
    if (globalThis.createImageBitmap)
      f = await createImageBitmap(i);
    else if (globalThis.Image) {
      f = new Image();
      let w = "";
      try {
        w = URL.createObjectURL(i), f.src = w, await f.decode();
      } finally {
        URL.revokeObjectURL(w);
      }
    } else
      return i;
  } catch {
    throw new DOMException(
      "Failed to load or decode Blob.",
      "InvalidStateError"
    );
  }
  return await fr(f);
}
function io(i) {
  const { width: f, height: c } = i;
  if (f === 0 || c === 0)
    return null;
  const w = i.getContext("2d");
  try {
    return w.getImageData(0, 0, f, c);
  } catch {
    throw new DOMException("Source would taint origin.", "SecurityError");
  }
}
async function so(i) {
  if (hr(i))
    return await oo(i);
  if (no(i)) {
    if (ho(i))
      throw new DOMException(
        "The image data has been detached.",
        "InvalidStateError"
      );
    return i;
  }
  return ur(i) || lr(i) ? io(i) : await fr(i);
}
async function uo(i) {
  try {
    return await i.decode(), !0;
  } catch {
    return !1;
  }
}
async function co(i) {
  var f;
  try {
    return await ((f = i.decode) == null ? void 0 : f.call(i)), !0;
  } catch {
    return !1;
  }
}
function lo(i) {
  return i.format === null;
}
function ho(i) {
  return i.data.buffer.byteLength === 0;
}
function fo(i) {
  return i.width === 0 && i.height === 0;
}
function er(i, f) {
  return i instanceof DOMException ? new DOMException(`${f}: ${i.message}`, i.name) : i instanceof Error ? new i.constructor(`${f}: ${i.message}`) : new Error(`${f}: ${i}`);
}
var lt;
class yo extends EventTarget {
  constructor(c = {}) {
    var w;
    super();
    Ze(this, lt, void 0);
    try {
      const v = (w = c == null ? void 0 : c.formats) == null ? void 0 : w.filter(
        ($) => $ !== "unknown"
      );
      if ((v == null ? void 0 : v.length) === 0)
        throw new TypeError("Hint option provided, but is empty.");
      for (const $ of v != null ? v : [])
        if (!Bt.has($))
          throw new TypeError(
            `Failed to read the 'formats' property from 'BarcodeDetectorOptions': The provided value '${$}' is not a valid enum value of type BarcodeFormat.`
          );
      Je(this, lt, v != null ? v : []), Za().then(($) => {
        this.dispatchEvent(
          new CustomEvent("load", {
            detail: $
          })
        );
      }).catch(($) => {
        this.dispatchEvent(new CustomEvent("error", { detail: $ }));
      });
    } catch (v) {
      throw er(
        v,
        "Failed to construct 'BarcodeDetector'"
      );
    }
  }
  static async getSupportedFormats() {
    return to.filter((c) => c !== "unknown");
  }
  async detect(c) {
    try {
      const w = await so(c);
      if (w === null)
        return [];
      let v;
      try {
        hr(w) ? v = await Ja(w, {
          tryHarder: !0,
          formats: se(this, lt).map(($) => Bt.get($))
        }) : v = await Ka(w, {
          tryHarder: !0,
          formats: se(this, lt).map(($) => Bt.get($))
        });
      } catch ($) {
        throw console.error($), new DOMException(
          "Barcode detection service unavailable.",
          "NotSupportedError"
        );
      }
      return v.map(($) => {
        const {
          topLeft: { x: B, y: U },
          topRight: { x: V, y: H },
          bottomLeft: { x: M, y: K },
          bottomRight: { x: L, y: ht }
        } = $.position, X = Math.min(B, V, M, L), tt = Math.min(U, H, K, ht), at = Math.max(B, V, M, L), _t = Math.max(U, H, K, ht);
        return {
          boundingBox: new DOMRectReadOnly(
            X,
            tt,
            at - X,
            _t - tt
          ),
          rawValue: $.text,
          format: eo($.format),
          cornerPoints: [
            {
              x: B,
              y: U
            },
            {
              x: V,
              y: H
            },
            {
              x: L,
              y: ht
            },
            {
              x: M,
              y: K
            }
          ]
        };
      });
    } catch (w) {
      throw er(
        w,
        "Failed to execute 'detect' on 'BarcodeDetector'"
      );
    }
  }
}
lt = new WeakMap();
export {
  yo as BarcodeDetector,
  mo as setZXingModuleOverrides
};
